import "./sbloading.scss";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";

const SbLoading = ({
  size, // sm, md
  fullPage,
  customClass,
}) => {
  return (
    <div
      className={`sb-loading${fullPage ? " sb-loading--full-page" : ""}${
        customClass?.length > 0 ? ` sb-loading--${customClass}` : ""
      }`}
    >
      <Spinner
        as="div"
        size={size}
        role="status"
        animation="border"
        aria-hidden="true"
        className={`sb-spinner--${size}`}
      />
    </div>
  );
};

export default SbLoading;

SbLoading.propTypes = {
  fullPage: PropTypes.bool,
  customClass: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
};

SbLoading.defaultProps = {
  size: "sm",
  fullPage: false,
};
